export default __webpack_public_path__ + "static/rhc-a1d1fc10f0ff7dda8c9dd25ac24ba144.png";